const BitManipulation = [
    {
      Topic: "Bit Manipulation",
      Problem: "Count set bits in an integer",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/set-bits0143/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/set-bits_1164179?topList=love-babbar-dsa-sheet-problems",
      Id: 1
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Find the two non-repeating elements in an array of repeating elements",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/finding-the-numbers0215/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/unique-pair-using-bits_972997?topList=love-babbar-dsa-sheet-problems",
      Id: 2
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Count number of bits to be flipped to convert A to B",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/bit-difference/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/number-of-flips_3125902?topList=love-babbar-dsa-sheet-problems",
      Id: 3
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Count total set bits in all numbers from 1 to n",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/count-total-set-bits/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/count-set-bits_1112627?topList=love-babbar-dsa-sheet-problems",
      Id: 4
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Program to find whether a no is power of two",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/power-of-2/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/power-of-two_893061?topList=love-babbar-dsa-sheet-problems",
      Id: 5
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Find position of the only set bit",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/find-position-of-set-bit3706/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/find-the-lone-set-bit_1062725?topList=love-babbar-dsa-sheet-problems",
      Id: 6
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Copy set bits in a range",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/copy-set-bits-in-a-range/",
      URL2: "https://www.codingninjas.com/codestudio/problems/copy-bits-in-range_3150011?topList=love-babbar-dsa-sheet-problems",
      Id: 7
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Divide two integers without using multiplication, division and mod operator",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/divide-two-integers-without-using-multiplication-division-mod-operator/",
      URL2: "https://www.codingninjas.com/codestudio/problems/divide-two-integers_1112617?topList=love-babbar-dsa-sheet-problems",
      Id: 8
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Calculate square of a number without using *, / and pow()",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/calculate-square-of-a-number-without-using-and-pow/",
      URL2: "https://www.codingninjas.com/codestudio/problems/calculate-square-of-a-number_1112623?topList=love-babbar-dsa-sheet-problems",
      Id: 9
    },
    {
      Topic: "Bit Manipulation",
      Problem: "Power Set",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/power-set4302/1",
      URL2: "",
      Id: 10
    }
  ];

export default BitManipulation;